



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import ActivationEmailList from '@/componentsV2/organisms/ActivationEmailList/ActivationEmailList.vue';

import { IActivationEmail } from '@/models/integrations-activation-emails';
import ActivationEmailService from '@/api/ActivationEmailService';
import ActivationEmailsEmptyState from '@/views/ActivationEmails/ActivationEmailsEmptyState.vue';

@Component({
  components: {
    SectionWrapper,
    ActivationEmailList,
    ActivationEmailsEmptyState
  }
})
export default class IntegrationsActivationEmailsList extends Vue {
  @Prop({ default: true }) showTitle?: boolean;

  activationEmailService = new ActivationEmailService();
  email: Partial<IActivationEmail> = {};
  emptyState = true;
  loading = false;

  get tPrefix() {
    return 'emailAutomation';
  }

  get title() {
    return this.showTitle ? this.$t(`${this.tPrefix}.title`) : null;
  }

  @Watch('loading')
  changedLoading() {
    this.$emit('setLoading', this.loading);
  }

  async handleChangeEnabled() {
    try {
      this.$showLoaderWithLocker();
      await this.activationEmailService.putActivationEmailEnabled(
        !this.email.enabled
      );
    } finally {
      this.email.enabled = !this.email.enabled;
      this.$hideLoader();
    }
  }

  async checkEmailActivationStatus() {
    try {
      this.$showLoaderWithLocker();
      this.loading = true;

      const { data } = await this.activationEmailService.getActivationEmail();
      this.email = {
        title: this.$t(`${this.tPrefix}.email.title`) as string,
        description: this.$t(`${this.tPrefix}.email.description`) as string,
        ...data
      };

      if (data.enabledAt) this.emptyState = false;

      this.$emit('changedEmptyState', this.emptyState);
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  mounted() {
    this.checkEmailActivationStatus();
  }
}
